import { Component, Input } from "@angular/core";
import { DataListItem } from "./datalistitem/datalistitem.component";

@Component({
    standalone: false,
    selector: "data-list",
    templateUrl: "./datalist.component.html",
})
export class DataList {
    @Input() dataset;
    @Input() enableFilter = false;
    @Input() url;
    @Input() show4Columns = false;
    items: DataListItem[] = [];
    query = "";
    filteredList;

    addItem(item) {
        this.items.push(item);
    }

    getData() {
        if (this.query !== "") {
            return this.filteredList;
        } else {
            return this.dataset;
        }
    }

    buildUrl(baseUrl: string, url, id: number): string {
        return baseUrl + (url || "") + (id === undefined ? "" : id);
    }

    filter() {
        this.filteredList = this.dataset.filter(
            function (el) {
                var result = "";
                for (var key in el) {
                    result += el[key];
                }
                return (
                    result.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                );
            }.bind(this)
        );
    }
}
